import GeneralButton from "../common/GeneralButton";
import { TiPlus } from "react-icons/ti";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./homePartial.css";
import { HiChevronDoubleRight, HiChevronRight } from "react-icons/hi";
import Icon from "../common/Icon";
import ProductCarousel from "./ProductCarousel";
const SpotLight = ({ slides, position, products }) => {
  return (
    <>
      <div className="relative  h-[248px]">
        {" "}
        {/* fixed height */}
        <Swiper
          direction={slides.length > 1 ? "vertical" : "horizontal"} // vertical mode
          modules={[Pagination]}
          pagination={{ clickable: true }}
          loop={slides.length > 2}
          className={`rounded-2xl overflow-hidden shadow-md  h-full min-h-[248px] ${
            slides.length > 1 ? "vertical standards-swiper" : ""
          }`}
        >
          {slides
            ?.sort((a, b) => a.sortOrder - b.sortOrder) // ✅ sorted by sortOrder
            .map((slide, index) => (
              <SwiperSlide key={index}>
                {position === "Left" && (
                  <>
                    {slide.imagePosition === "Left" && (
                      <>
                        <div
                          className="w-full h-full  flex items-center justify-between relative min-h-[248px]"
                          style={{
                            backgroundColor: slide.slideBackgroundColor,
                          }}
                        >
                          <div
                            key={index}
                            className={`flex items-center gap-4 xl:gap-2 w-full rounded-xl p-6  md:px-6 xl:p-4 1xl:p-8`}
                          >
                            <div
                              className={`me-4 absolute left-7 bottom-8  min-w-[80px] xs:max-w-[130px] xs:h-[130px] xxs:max-w-[130px] xxs:h-[130px] md:w-auto md:h-auto md:relative md:left-0 md:bottom-0 ${
                                slide.imageSize === "Small"
                                  ? "xxs:max-w-[100px] xxs:max-h-[100px] md:max-w-[80px] md:max-h-[80px] "
                                  : "md:max-w-[120px] 1xl:max-w-[200px]"
                              }`}
                            >
                              <img
                                src={
                                  process.env.REACT_APP_BACKEND_URL +
                                  "public/" +
                                  slide.image
                                }
                                onError={(e) => {
                                  e.currentTarget.src = require("../../assets/images/link.png");
                                }}
                                className={
                                  slide?.imageSize === "Small"
                                    ? "w-full h-full max-h-[100px]   object-contain"
                                    : "w-full h-full max-h-[200px]   object-contain"
                                }
                              />
                            </div>
                            <div className="flex flex-col gap-2 me-2  text-balance w-[65%]  ">
                              <div
                                className={`${
                                  slide.buttonText
                                    ? "absolute md:relative  top-5 z-[100] md:right-0 md:top-0 "
                                    : ""
                                } ${
                                  slides.length > 1 ? "right-12" : "right-7"
                                }`}
                              >
                                <h2
                                  className={`${
                                    slides.length > 1 && !slide.buttonText
                                      ? "text-32pt  "
                                      : slides.length > 1
                                      ? "text-32pt "
                                      : "text-32pt"
                                  }  xs:text-28pt xl:text-28pt md:text-32pt ${
                                    position === "Right"
                                      ? "md:text-[42pt] xl:text-28pt"
                                      : ""
                                  }  leading-none text-right md:text-left`}
                                  style={{
                                    color: slide.heading1Color || "#333",
                                  }}
                                >
                                  {slide.heading1}
                                </h2>
                                {slide.heading2 && (
                                  <h2
                                    className={` ${
                                      slides.length > 1 && !slide.buttonText
                                        ? "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                        : slides.length > 1
                                        ? "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                        : "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                    }  text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px] leading-none ${
                                      position === "Right"
                                        ? "text-[40px] sm:text-[48px] md:text-[48pt] xl:text-[28pt]"
                                        : ""
                                    }  text-right md:text-left `}
                                    style={{
                                      color: slide.heading2Color || "#333",
                                    }}
                                  >
                                    {slide.heading2}
                                  </h2>
                                )}
                              </div>
                              {slide.buttonText && (
                                <GeneralButton
                                  className={`text-24pt md:text-18pt 1xl:text-24pt leading-tight absolute md:relative  bottom-12 z-[100] md:right-0 md:bottom-0  ${
                                    slides.length > 1 ? "right-12" : "right-7"
                                  } ${
                                    position === "Right"
                                      ? "md:text-[24px] xl:text-18pt"
                                      : ""
                                  }`}
                                  text={slide.buttonText || "Learn More"}
                                  bgColor={
                                    slide.buttonBackgroundColor || "#ff6600"
                                  }
                                  textColor={slide.buttonTextColor || "#fff"}
                                  icon={
                                    slide.buttonIcon === "Plus" ? (
                                      <TiPlus size={15} />
                                    ) : slide.buttonIcon === "Right Arrow" ? (
                                      <HiChevronRight size={20} />
                                    ) : null
                                  }
                                  onClick={() =>
                                    (window.location.href = slide.buttonLink)
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {slide.imagePosition === "Right" && (
                      <>
                        <div
                          className="w-full h-full  flex items-center justify-between relative min-h-[248px]"
                          style={{
                            backgroundColor: slide.slideBackgroundColor,
                          }}
                        >
                          <div
                            key={index}
                            className={`flex flex-row-reverse items-center gap-4 xl:gap-2 w-full rounded-xl p-6  md:px-6 xl:p-4 1xl:p-8`}
                          >
                            <div
                              className={`me-4 absolute left-7 bottom-8  min-w-[80px] xs:max-w-[130px] xs:h-[130px] xxs:max-w-[130px] xxs:h-[130px] md:w-auto md:h-auto md:relative md:left-0 md:bottom-0 ${
                                slide.imageSize === "Small"
                                  ? "xxs:max-w-[100px] xxs:max-h-[100px] md:max-w-[80px] md:max-h-[80px] "
                                  : "md:max-w-[120px] 1xl:max-w-[200px]"
                              }`}
                            >
                              <img
                                src={
                                  process.env.REACT_APP_BACKEND_URL +
                                  "public/" +
                                  slide.image
                                }
                                onError={(e) => {
                                  e.currentTarget.src = require("../../assets/images/link.png");
                                }}
                                className={
                                  slide?.imageSize === "Small"
                                    ? "w-full h-full max-h-[100px]   object-contain"
                                    : "w-full h-full max-h-[200px]   object-contain"
                                }
                              />
                            </div>
                            <div className="flex flex-col gap-2 me-2  text-balance w-[65%]  ">
                              <div
                                className={`${
                                  slide.buttonText
                                    ? "absolute md:relative  top-5 z-[100] md:right-0 md:top-0 "
                                    : ""
                                } ${
                                  slides.length > 1 ? "right-12" : "right-7"
                                }`}
                              >
                                <h2
                                  className={`${
                                    slides.length > 1 && !slide.buttonText
                                      ? "text-32pt  "
                                      : slides.length > 1
                                      ? "text-32pt "
                                      : "text-32pt"
                                  }  xs:text-28pt xl:text-28pt md:text-32pt ${
                                    position === "Right"
                                      ? "md:text-[42pt] xl:text-28pt"
                                      : ""
                                  }  leading-none text-right md:text-left`}
                                  style={{
                                    color: slide.heading1Color || "#333",
                                  }}
                                >
                                  {slide.heading1}
                                </h2>
                                {slide.heading2 && (
                                  <h2
                                    className={` ${
                                      slides.length > 1 && !slide.buttonText
                                        ? "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                        : slides.length > 1
                                        ? "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                        : "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                    }  text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px] leading-none ${
                                      position === "Right"
                                        ? "text-[40px] sm:text-[48px] md:text-[48pt] xl:text-[28pt]"
                                        : ""
                                    }  text-right md:text-left `}
                                    style={{
                                      color: slide.heading2Color || "#333",
                                    }}
                                  >
                                    {slide.heading2}
                                  </h2>
                                )}
                              </div>
                              {slide.buttonText && (
                                <GeneralButton
                                  className={`text-24pt md:text-18pt 1xl:text-24pt leading-tight absolute md:relative  bottom-12 z-[100] md:right-0 md:bottom-0  ${
                                    slides.length > 1 ? "right-12" : "right-7"
                                  } ${
                                    position === "Right"
                                      ? "md:text-[24px] xl:text-18pt"
                                      : ""
                                  }`}
                                  text={slide.buttonText || "Learn More"}
                                  bgColor={
                                    slide.buttonBackgroundColor || "#ff6600"
                                  }
                                  textColor={slide.buttonTextColor || "#fff"}
                                  icon={
                                    slide.buttonIcon === "Plus" ? (
                                      <TiPlus size={15} />
                                    ) : slide.buttonIcon === "Right Arrow" ? (
                                      <HiChevronRight size={20} />
                                    ) : null
                                  }
                                  onClick={() =>
                                    (window.location.href = slide.buttonLink)
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}

                {position === "Center" && (
                  <>
                    {slide.imagePosition === "Left" && (
                      <>
                        <div
                          className="w-full h-full  flex items-center justify-between relative min-h-[248px]"
                          style={{
                            backgroundColor: slide.slideBackgroundColor,
                          }}
                        >
                          <div
                            key={index}
                            className={`flex items-center gap-4 xl:gap-2 w-full rounded-xl p-6  md:px-6 xl:p-4 1xl:p-8`}
                          >
                            <div
                              className={`me-4 bg-white rounded-full absolute left-7 bottom-8 md:relative md:left-0 md:bottom-0  ${
                                slide.imageSize === "Small"
                                  ? "min-w-[80px] min-h-[80px] lg:min-w-[100px] lg:min-h-[100px]"
                                  : "min-w-[100px] min-h-[100px] lg:min-w-[120px] lg:min-h-[120px] xl:min-w-[140px] xl:min-h-[140px] 2.5xl:min-w-[170px] 2.5xl:min-h-[170px]"
                              }`}
                            >
                              <ProductCarousel
                                products={products}
                                className={
                                  slide.imageSize === "Small"
                                    ? "min-w-[80px] min-h-[80px] lg:min-w-[100px] lg:min-h-[100px]"
                                    : "min-w-[100px] min-h-[100px] md:min-w-[100px] md:min-h-[100px] lg:min-w-[120px] lg:min-h-[120px] xl:min-w-[120px] xl:min-h-[120px] 2.5xl:min-w-[170px] 2.5xl:min-h-[170px]"
                                }
                                className2={`
                                  ${
                                    slide.imageSize === "Small"
                                      ? "absolute -left-5 -top-2 md:-left-5 md:-top-2  lg:-left-7 1xl:-left-8 1xl:-top-4  max-w-[100px] max-h-[100px] lg:max-w-[120px] lg:max-h-[120px]"
                                      : "absolute -left-8 -top-2 md:-left-6 md:-top-2  lg:-left-10 lg:-top-4 1xl:-left-14 1xl:-top-7 2.5xl:-left-12 2.5xl:-top-5  max-w-[130px] max-h-[130px] md:max-w-[110px] md:max-h-[110px] lg:max-w-[150px] lg:max-h-[150px] xl:max-w-[180px] xl:max-h-[180px] 2.5xl:max-w-[200px] 2.5xl:max-h-[200px]"
                                  }`}
                                icon={
                                  slide.imageSize === "Small"
                                    ? "bottom-0 -right-0 md:-bottom-0 md:right-1 1xl:-bottom-0 1xl:right-1 2.5xl:-bottom-2 2.5xl:right-1"
                                    : "-bottom-[1px] right-2  xl:bottom-2 xl:right-2 1xl:-bottom-4 1xl:right-2  2.5xl:-bottom-[4px] 2.5xl:right-4"
                                }
                              />
                            </div>

                            <div className="flex flex-col gap-2 me-2  text-balance w-[65%]  ">
                              <div
                                className={`${
                                  slide.buttonText
                                    ? "absolute md:relative  top-5 z-[100] md:right-0 md:top-0 "
                                    : ""
                                } ${
                                  slides.length > 1 ? "right-12" : "right-7"
                                }`}
                              >
                                <h2
                                  className={`${
                                    slides.length > 1 && !slide.buttonText
                                      ? "text-32pt  "
                                      : slides.length > 1
                                      ? "text-32pt "
                                      : "text-32pt"
                                  }  xs:text-28pt xl:text-28pt md:text-32pt ${
                                    position === "Right"
                                      ? "md:text-[42pt] xl:text-28pt"
                                      : ""
                                  }  leading-none text-right md:text-left`}
                                  style={{
                                    color: slide.heading1Color || "#333",
                                  }}
                                >
                                  {slide.heading1}
                                </h2>
                                {slide.heading2 && (
                                  <h2
                                    className={` ${
                                      slides.length > 1 && !slide.buttonText
                                        ? "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                        : slides.length > 1
                                        ? "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                        : "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                    }  text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px] leading-none ${
                                      position === "Right"
                                        ? "text-[40px] sm:text-[48px] md:text-[48pt] xl:text-[28pt]"
                                        : ""
                                    }  text-right md:text-left `}
                                    style={{
                                      color: slide.heading2Color || "#333",
                                    }}
                                  >
                                    {slide.heading2}
                                  </h2>
                                )}
                              </div>
                              {slide.buttonText && (
                                <GeneralButton
                                  className={`text-24pt md:text-18pt 1xl:text-24pt leading-tight absolute md:relative  bottom-12 z-[100] md:right-0 md:bottom-0  ${
                                    slides.length > 1 ? "right-12" : "right-7"
                                  } ${
                                    position === "Right"
                                      ? "md:text-[24px] xl:text-18pt"
                                      : ""
                                  }`}
                                  text={slide.buttonText || "Learn More"}
                                  bgColor={
                                    slide.buttonBackgroundColor || "#ff6600"
                                  }
                                  textColor={slide.buttonTextColor || "#fff"}
                                  icon={
                                    slide.buttonIcon === "Plus" ? (
                                      <TiPlus size={15} />
                                    ) : slide.buttonIcon === "Right Arrow" ? (
                                      <HiChevronRight size={20} />
                                    ) : null
                                  }
                                  onClick={() =>
                                    (window.location.href = slide.buttonLink)
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {slide.imagePosition === "Right" && (
                      <>
                        <div
                          className="w-full h-full  flex items-center justify-between relative min-h-[248px]"
                          style={{
                            backgroundColor: slide.slideBackgroundColor,
                          }}
                        >
                          <div
                            key={index}
                            className={`flex flex-row-reverse 1xl:justify-between items-center gap-4 xl:gap-2 w-full rounded-xl p-6  md:px-6 xl:p-4 1xl:p-8`}
                          >
                            <div
                              className={`bg-white rounded-full absolute left-7 bottom-8 md:relative md:left-0 md:bottom-0  ${
                                slide.imageSize === "Small"
                                  ? "min-w-[80px] min-h-[80px] lg:min-w-[100px] lg:min-h-[100px]"
                                  : "min-w-[100px] min-h-[100px] lg:min-w-[120px] lg:min-h-[120px] xl:min-w-[140px] xl:min-h-[140px] 2.5xl:min-w-[199px] 2.5xl:min-h-[199px]"
                              }`}
                            >
                                <ProductCarousel
                                products={products}
                                className={
                                  slide.imageSize === "Small"
                                    ? "min-w-[80px] min-h-[80px] lg:min-w-[100px] lg:min-h-[100px]"
                                    : "min-w-[100px] min-h-[100px] md:min-w-[100px] md:min-h-[100px] lg:min-w-[120px] lg:min-h-[120px] xl:min-w-[120px] xl:min-h-[120px] 2.5xl:min-w-[170px] 2.5xl:min-h-[170px]"
                                }
                                className2={`
                                  ${
                                    slide.imageSize === "Small"
                                      ? "absolute -left-5 -top-2 md:-left-5 md:-top-2  lg:-left-7 1xl:-left-8 1xl:-top-4  max-w-[100px] max-h-[100px] lg:max-w-[120px] lg:max-h-[120px]"
                                      : "absolute -left-8 -top-2 md:-left-6 md:-top-2  lg:-left-10 lg:-top-4 1xl:-left-14 1xl:-top-7 2.5xl:-left-16 2.5xl:-top-8  max-w-[130px] max-h-[130px] md:max-w-[110px] md:max-h-[110px] lg:max-w-[150px] lg:max-h-[150px] xl:max-w-[180px] xl:max-h-[180px] 2.5xl:max-w-[240px] 2.5xl:max-h-[240px]"
                                  }`}
                                icon={
                                  slide.imageSize === "Small"
                                    ? "bottom-0 -right-0 md:-bottom-0 md:right-1 1xl:-bottom-0 1xl:right-1 2.5xl:-bottom-2 2.5xl:right-1"
                                    : "-bottom-[1px] right-2  xl:bottom-2 xl:right-2 1xl:-bottom-4 1xl:right-2  2.5xl:-bottom-[18px] 2.5xl:right-4"
                                }
                              />
                            </div>

                            {/* <div
                              className={`me-4 xl:bg-white absolute left-7 bottom-8  min-w-[80px]  rounded-full xl:min-w-[130px] xl:min-h-[130px] 2.5xl:min-w-[160px] 2.5xl:min-h-[160px] xs:max-w-[130px] xs:h-[130px] xxs:max-w-[130px] xxs:h-[130px] md:w-auto md:h-auto md:relative md:left-0 md:bottom-0 ${
                                slide.imageSize === "Small"
                                  ? "xxs:max-w-[100px] xxs:max-h-[100px] md:max-w-[80px] md:max-h-[80px] "
                                  : "md:max-w-[120px] 1xl:max-w-[200px]"
                              }`}
                            >
                              <ProductCarousel
                                products={products}
                                className="
      xl:min-w-[130px] xl:min-h-[130px]
      2.5xl:min-w-[160px] 2.5xl:min-h-[160px]
      min-w-[80px] xs:max-w-[130px] xs:h-[130px]
      xxs:max-w-[130px] xxs:h-[130px]
    "
                              />
                            </div> */}
                            <div className="flex flex-col gap-2 me-2  text-balance w-[65%]  ">
                              <div
                                className={`${
                                  slide.buttonText
                                    ? "absolute md:relative  top-5 z-[100] md:right-0 md:top-0 "
                                    : ""
                                } ${
                                  slides.length > 1 ? "right-12" : "right-7"
                                }`}
                              >
                                <h2
                                  className={`${
                                    slides.length > 1 && !slide.buttonText
                                      ? "text-32pt  "
                                      : slides.length > 1
                                      ? "text-32pt "
                                      : "text-32pt"
                                  }  xs:text-28pt xl:text-28pt md:text-32pt ${
                                    position === "Right"
                                      ? "md:text-[42pt] xl:text-28pt"
                                      : ""
                                  }  leading-none text-right md:text-left`}
                                  style={{
                                    color: slide.heading1Color || "#333",
                                  }}
                                >
                                  {slide.heading1}
                                </h2>
                                {slide.heading2 && (
                                  <h2
                                    className={` ${
                                      slides.length > 1 && !slide.buttonText
                                        ? "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                        : slides.length > 1
                                        ? "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                        : "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                    }  text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px] leading-none ${
                                      position === "Right"
                                        ? "text-[40px] sm:text-[48px] md:text-[48pt] xl:text-[28pt]"
                                        : ""
                                    }  text-right md:text-left `}
                                    style={{
                                      color: slide.heading2Color || "#333",
                                    }}
                                  >
                                    {slide.heading2}
                                  </h2>
                                )}
                              </div>
                              {slide.buttonText && (
                                <GeneralButton
                                  className={`text-24pt md:text-18pt 1xl:text-24pt leading-tight absolute md:relative  bottom-12 z-[100] md:right-0 md:bottom-0  ${
                                    slides.length > 1 ? "right-12" : "right-7"
                                  } ${
                                    position === "Right"
                                      ? "md:text-[24px] xl:text-18pt"
                                      : ""
                                  }`}
                                  text={slide.buttonText || "Learn More"}
                                  bgColor={
                                    slide.buttonBackgroundColor || "#ff6600"
                                  }
                                  textColor={slide.buttonTextColor || "#fff"}
                                  icon={
                                    slide.buttonIcon === "Plus" ? (
                                      <TiPlus size={15} />
                                    ) : slide.buttonIcon === "Right Arrow" ? (
                                      <HiChevronRight size={20} />
                                    ) : null
                                  }
                                  onClick={() =>
                                    (window.location.href = slide.buttonLink)
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}

                {position === "Right" && (
                  <>
                    {slide.imagePosition === "Left" && (
                      <>
                        <div
                          className="w-full h-full  flex items-center justify-between relative min-h-[248px]"
                          style={{
                            backgroundColor: slide.slideBackgroundColor,
                          }}
                        >
                          <div
                            key={index}
                            className={`flex items-center gap-4 xl:gap-2 w-full rounded-xl p-6  md:px-6 xl:p-4 1xl:p-8`}
                          >
                            <div
                              className={`me-4 absolute left-7 bottom-8  min-w-[80px] xs:max-w-[130px] xs:h-[130px] xxs:max-w-[130px] xxs:h-[130px] md:w-auto md:h-auto md:relative md:left-0 md:bottom-0 ${
                                slide.imageSize === "Small"
                                  ? "xxs:max-w-[100px] xxs:max-h-[100px] md:max-w-[80px] md:max-h-[80px] "
                                  : "md:max-w-[120px] 1xl:max-w-[200px]"
                              }`}
                            >
                              <img
                                src={
                                  process.env.REACT_APP_BACKEND_URL +
                                  "public/" +
                                  slide.image
                                }
                                onError={(e) => {
                                  e.currentTarget.src = require("../../assets/images/link.png");
                                }}
                                className={
                                  slide?.imageSize === "Small"
                                    ? "w-full h-full max-h-[100px]   object-contain"
                                    : "w-full h-full max-h-[200px]   object-contain"
                                }
                              />
                            </div>
                            <div className="flex flex-col gap-2 me-2  text-balance w-[65%]  ">
                              <div
                                className={`${
                                  slide.buttonText
                                    ? "absolute md:relative  top-5 z-[100] md:right-0 md:top-0 "
                                    : ""
                                } ${
                                  slides.length > 1 ? "right-12" : "right-7"
                                }`}
                              >
                                <h2
                                  className={`${
                                    slides.length > 1 && !slide.buttonText
                                      ? "text-32pt  "
                                      : slides.length > 1
                                      ? "text-32pt "
                                      : "text-32pt"
                                  }  xs:text-28pt xl:text-28pt md:text-32pt ${
                                    position === "Right"
                                      ? "md:text-[42pt] xl:text-28pt"
                                      : ""
                                  }  leading-none text-right md:text-left`}
                                  style={{
                                    color: slide.heading1Color || "#333",
                                  }}
                                >
                                  {slide.heading1}
                                </h2>
                                {slide.heading2 && (
                                  <h2
                                    className={` ${
                                      slides.length > 1 && !slide.buttonText
                                        ? "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                        : slides.length > 1
                                        ? "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                        : "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                    }  text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px] leading-none ${
                                      position === "Right"
                                        ? "text-[40px] sm:text-[48px] md:text-[48pt] xl:text-[28pt]"
                                        : ""
                                    }  text-right md:text-left `}
                                    style={{
                                      color: slide.heading2Color || "#333",
                                    }}
                                  >
                                    {slide.heading2}
                                  </h2>
                                )}
                              </div>
                              {slide.buttonText && (
                                <GeneralButton
                                  className={`text-24pt md:text-18pt 1xl:text-24pt leading-tight absolute md:relative  bottom-12 z-[100] md:right-0 md:bottom-0  ${
                                    slides.length > 1 ? "right-12" : "right-7"
                                  } ${
                                    position === "Right"
                                      ? "md:text-[24px] xl:text-18pt"
                                      : ""
                                  }`}
                                  text={slide.buttonText || "Learn More"}
                                  bgColor={
                                    slide.buttonBackgroundColor || "#ff6600"
                                  }
                                  textColor={slide.buttonTextColor || "#fff"}
                                  icon={
                                    slide.buttonIcon === "Plus" ? (
                                      <TiPlus size={15} />
                                    ) : slide.buttonIcon === "Right Arrow" ? (
                                      <HiChevronRight size={20} />
                                    ) : null
                                  }
                                  onClick={() =>
                                    (window.location.href = slide.buttonLink)
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {slide.imagePosition === "Right" && (
                      <>
                        <div
                          className="w-full h-full  flex items-center justify-between relative min-h-[248px]"
                          style={{
                            backgroundColor: slide.slideBackgroundColor,
                          }}
                        >
                          <div
                            key={index}
                            className={`flex flex-row-reverse items-center gap-4 xl:gap-2 w-full rounded-xl p-6  md:px-6 xl:p-4 1xl:p-8`}
                          >
                            <div
                              className={`me-4 absolute left-7 bottom-8  min-w-[80px] xs:max-w-[130px] xs:h-[130px] xxs:max-w-[130px] xxs:h-[130px] md:w-auto md:h-auto md:relative md:left-0 md:bottom-0 ${
                                slide.imageSize === "Small"
                                  ? "xxs:max-w-[100px] xxs:max-h-[100px] md:max-w-[80px] md:max-h-[80px] "
                                  : "md:max-w-[120px] 1xl:max-w-[200px]"
                              }`}
                            >
                              <img
                                src={
                                  process.env.REACT_APP_BACKEND_URL +
                                  "public/" +
                                  slide.image
                                }
                                onError={(e) => {
                                  e.currentTarget.src = require("../../assets/images/link.png");
                                }}
                                className={
                                  slide?.imageSize === "Small"
                                    ? "w-full h-full max-h-[100px]   object-contain"
                                    : "w-full h-full max-h-[200px]   object-contain"
                                }
                              />
                            </div>
                            <div className="flex flex-col gap-2 me-2  text-balance w-[65%]  ">
                              <div
                                className={`${
                                  slide.buttonText
                                    ? "absolute md:relative  top-5 z-[100] md:right-0 md:top-0 "
                                    : ""
                                } ${
                                  slides.length > 1 ? "right-12" : "right-7"
                                }`}
                              >
                                <h2
                                  className={`${
                                    slides.length > 1 && !slide.buttonText
                                      ? "text-32pt  "
                                      : slides.length > 1
                                      ? "text-32pt "
                                      : "text-32pt"
                                  }  xs:text-28pt xl:text-28pt md:text-32pt ${
                                    position === "Right"
                                      ? "md:text-[42pt] xl:text-28pt"
                                      : ""
                                  }  leading-none text-right md:text-left`}
                                  style={{
                                    color: slide.heading1Color || "#333",
                                  }}
                                >
                                  {slide.heading1}
                                </h2>
                                {slide.heading2 && (
                                  <h2
                                    className={` ${
                                      slides.length > 1 && !slide.buttonText
                                        ? "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                        : slides.length > 1
                                        ? "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                        : "text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px]"
                                    }  text-[40px] sm:text-[48px]  md:text-[32px] 1xl:text-[43px] 3xl:text-[48px] leading-none ${
                                      position === "Right"
                                        ? "text-[40px] sm:text-[48px] md:text-[48pt] xl:text-[28pt]"
                                        : ""
                                    }  text-right md:text-left `}
                                    style={{
                                      color: slide.heading2Color || "#333",
                                    }}
                                  >
                                    {slide.heading2}
                                  </h2>
                                )}
                              </div>
                              {slide.buttonText && (
                                <GeneralButton
                                  className={`text-24pt md:text-18pt 1xl:text-24pt leading-tight absolute md:relative  bottom-12 z-[100] md:right-0 md:bottom-0  ${
                                    slides.length > 1 ? "right-12" : "right-7"
                                  } ${
                                    position === "Right"
                                      ? "md:text-[24px] xl:text-18pt"
                                      : ""
                                  }`}
                                  text={slide.buttonText || "Learn More"}
                                  bgColor={
                                    slide.buttonBackgroundColor || "#ff6600"
                                  }
                                  textColor={slide.buttonTextColor || "#fff"}
                                  icon={
                                    slide.buttonIcon === "Plus" ? (
                                      <TiPlus size={15} />
                                    ) : slide.buttonIcon === "Right Arrow" ? (
                                      <HiChevronRight size={20} />
                                    ) : null
                                  }
                                  onClick={() =>
                                    (window.location.href = slide.buttonLink)
                                  }
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </SwiperSlide>
            ))}
        </Swiper>
      </div>
    </>
  );
};

export default SpotLight;
